import partnershipsPortaventuraProductCardDesktopStyles from "./styles/portaventura.js";
const productCardMobileThemes = {
    partnershipsPortaventura: partnershipsPortaventuraProductCardDesktopStyles
};
export default productCardMobileThemes;

//# sourceMappingURL=index.js.map